import { LinkProps as NextLinkProps } from 'next/link';
import NextLink from 'next/link';
import { ForwardedRef, forwardRef, ReactNode } from 'react';

import { useSite } from 'src/hooks/useSite';

export type LinkProps = NextLinkProps & {
  className?: string;
  ref?: ForwardedRef<HTMLAnchorElement>;
  children: ReactNode;
  openNewTab?: boolean;
  url?: string;
};

const Link = forwardRef<HTMLAnchorElement, LinkProps>(function LinkComponent(
  props: LinkProps,
  ref
): JSX.Element {
  const { isEastAsiaSite } = useSite();
  const { children, className, openNewTab, ...otherProps } = props || {};

  const reviewHrefForCrossSiteLinking = () => {
    const relativeUrl = otherProps.href;
    const fullUrl = otherProps.url;

    if (fullUrl) {
      const urlObj = new URL(fullUrl);

      const isEastAsiaSiteUrl = urlObj.hostname.toLowerCase().includes('eastasia');
      const isCrossSiteUrl = (isEastAsiaSite && !isEastAsiaSiteUrl) || openNewTab;
      if (isCrossSiteUrl) {
        return {
          href: fullUrl,
          openInNewTab: true,
        };
      } else {
        return {
          href: relativeUrl,
          openInNewTab: false,
        };
      }
    } else {
      return {
        href: relativeUrl,
        openInNewTab: openNewTab,
      };
    }
  };

  const { href, openInNewTab } = reviewHrefForCrossSiteLinking();

  return (
    <NextLink
      className={className}
      ref={ref}
      {...otherProps}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      href={href}
    >
      {children}
    </NextLink>
  );
});

export default Link;
